// extracted by mini-css-extract-plugin
module.exports = {"container":"mfseo-module--container--21BAx","greyText":"mfseo-module--greyText--sHunP","heading1":"mfseo-module--heading1--3qdJ-","question":"mfseo-module--question--2UEEc"};